import { AnalystsEstimatesChartViewMode } from "../../../types";

export const DEFAULT_AVAILABLE_DATA = {
	hasAnnualsConsensus: false,
	hasQuartersConsensus: false,
	hasAnnualsStdDev: false,
	hasQuartersStdDev: false,
};

export const ESTIMATES_MODE_NAME = {
	[AnalystsEstimatesChartViewMode.DISPERSION]: "Consensus",
	[AnalystsEstimatesChartViewMode.STD_DEVIATION]: "Std Deviation",
};
